import { QueryType } from '../enums';

export const QueryTypes = [
  { name: 'Selector', value: QueryType.Selector },
  { name: 'Regex', value: QueryType.Regex },
  { name: 'Json', value: QueryType.JSON },
  { name: 'Contains Text', value: QueryType.Contains },
  { name: 'Parent', value: QueryType.Parent },
];
